export const css = {
    root: '_1Ki_c98p',
    nextstepCard: '_2KnCf-8q',
    textBlock: '_3hZXN8kl',
    heading: '_2ednqPx5',
    deck: 'E2-7kwkw',
    button: '_3P6X87wn',
    carouselBlock: '_37Qix400',
    nextstepBlock: '_2KuLdFC4',
    nextstepBox: '_1-wj_4qa',
    nextstepTitle: '_2VCFRg1K',
    nextstep: '_3wODWUyk',
    previous: '_1To2OZge',
    next: '_1jR5d3O1',
    largeArrow: '_1lxJRi1T',
    carousel: '_2BBVOCWk',
    extra: '_2lnoNBqH',
    complete: '_2iPQmCWK',
    ' _key': 'lp-widgets/lptoolcard'
};
export default css;
